namespace RioERP.Web.Enums {
    export enum EValidity {
        One = 0,
        Two = 1,
        Three = 2,
        Four = 3,
        Five = 4,
        Six = 5,
        Seven = 6,
        Eight = 7,
        Nine = 8,
        Ten = 9,
        Eleven = 10,
        Twelve = 11,
        Thirteen = 12,
        Fourteen = 13,
        Fifteen = 14,
        Sixteen = 15,
        Seventeen = 16,
        Eighteen = 17,
        Nineteen = 18,
        Twenty = 19,
        TwentyOne = 20,
        TwentyTwo = 21,
        TwentyThree = 22,
        TwentyFour = 23,
        TwentyFive = 24,
        TwentySix = 25,
        TwentySeven = 26,
        TwentyEight = 27,
        TwentyNine = 28,
        OneMonth = 29,
        OneAndHalfMonth = 30,
        TwoMonths = 31,
        TwoAndHalfMonths = 32,
        ThreeMonths = 33,
        FourMonths = 34,
        FiveMonths = 35,
        SixMonths = 36,
        SevenMonths = 37,
        EightMonths = 38,
        NineMonths = 39,
        TenMonths = 40,
        ElevenMonths = 41,
        TwelveMonths = 42,
        ThirteenMonths = 43,
        FourteenMonths = 44,
        FifteenMonths = 45,
        SixteenMonths = 46,
        EighteenMonths = 47,
        TwoYears = 48,
        TwoAndHalfYears = 49,
        ThreeYears = 50,
        FiveYears = 51,
        SevenYears = 52,
        TenYears = 53,
        FifteenYears = 54,
        TwentyYears = 55,
        TwentyFiveYears = 56,
        ThirtyYears = 57,
        Unlimited = 58
    }
    Serenity.Decorators.registerEnumType(EValidity, 'RioERP.Web.Enums.EValidity');
}
